import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Select } from '@ngxs/store';
import { NgxPrintDirective, NgxPrintModule } from 'ngx-print';
import { AuctionItem, ImageMetaData, LaunchDarklyService } from 'remarketing-angular-library';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { DetailsHeaderQuery } from 'src/sell/lib/details/interfaces/detail-header.query';
import { DetailsQueries } from 'src/sell/lib/details/queries/details.queries';
import { AutoVisionPrintVdpComponent } from '../auto-vision-print-vdp/auto-vision-print-vdp.component';
import { ConditionIndicatorComponent, VehicleDisclosuresIndicatorComponent, DatalistItemComponent } from 'remarketing-ui-components-lib';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-auto-vision-details-header',
    templateUrl: './auto-vision-details-header.component.html',
    styleUrls: ['./auto-vision-details-header.component.scss'],
    imports: [ConditionIndicatorComponent, VehicleDisclosuresIndicatorComponent, DatalistItemComponent, NgxPrintModule, NgTemplateOutlet, AutoVisionPrintVdpComponent, AsyncPipe]
})
export class AutoVisionDetailsHeaderComponent extends SaComponent implements OnInit {
  @ViewChild(NgxPrintDirective) ngxPrintDirective: NgxPrintDirective;
  @Select(DetailsQueries.header) header$: Observable<DetailsHeaderQuery>;
  @Select(DetailsQueries.images) images$: Observable<ImageMetaData[]>;

  auctionItem: AuctionItem;
  showPrintContent = false;
  autoVisionDetailsHeaderTranslations = {
    odometer: '',
    ariaLabelEmailVdp: '',
    altenvelope: '',
    ariaLabelPrint: '',
    distanceUnit: '',
    stockUnit: '',
    conditionIndicatorTranslations: ''
  };

  get autovisionPrintEmailEnabled() {
    return this.launchDarklyService.getFeatureFlag('vdp-autovision-printEmailEnabled', false);
  }

  get showEmailIcon(): boolean {
    return this.launchDarklyService.getFeatureFlag('vdp-emailEnabled', false);
  }

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly launchDarklyService: LaunchDarklyService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  goToEmail(inventoryItemUuid: string) {
    const link  = '../ui/vehicles/av/email?inventoryItem=' + inventoryItemUuid;
    window.open(link);
  }

  printVDP() {
    this.showPrintContent = true;
    setTimeout(() => {
      this.ngxPrintDirective.print();
    }, 1000);
  }

  getTranslations() {
    const keyParams = {
      'sellModule.details.detailsHeader': {},
      'common': {},
      'UIComponents': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        translate => {
          this.autoVisionDetailsHeaderTranslations.odometer = translate[0].odometer;
          this.autoVisionDetailsHeaderTranslations.ariaLabelEmailVdp = translate[0].ariaLabelEmailVdp;
          this.autoVisionDetailsHeaderTranslations.altenvelope = translate[0].altenvelope;
          this.autoVisionDetailsHeaderTranslations.ariaLabelPrint = translate[0].ariaLabelPrint;
          this.autoVisionDetailsHeaderTranslations.stockUnit = translate[0].stockUnit;
          this.autoVisionDetailsHeaderTranslations.distanceUnit = translate[1].distanceUnit;
          this.autoVisionDetailsHeaderTranslations.conditionIndicatorTranslations = translate[2].conditionIndicatorTranslations;
        },
        error => {
          console.log(error);
        }
      );
  }
}
